import { useContext } from 'react';
import { ApiClientContext } from '../../api_client';
import { ChatContext } from '../contexts/chat.context';
export class OpenAIError extends Error {
    type;
    param;
    code;
    constructor(message, type, param, code) {
        super(message);
        this.name = 'OpenAIError';
        this.type = type;
        this.param = param;
        this.code = code;
    }
}
export const useServerUtils = () => {
    const { apiClient: { post }, } = useContext(ApiClientContext);
    const { variables } = useContext(ChatContext);
    const openAIStream = async (messageProps) => {
        try {
            const { data } = await post(variables.autobuildAssistantEndpoint, {
                message: messageProps.message.content,
                // TODO: Study information needs to be provided as generic information -- to be changed when chat is integrated with study
                // study: JSON.stringify(currentStudy.toRosetta()),
            });
            return { response: data };
        }
        catch (e) {
            throw new Error('Error getting response from Medable AI Assistant');
        }
    };
    return { openAIStream };
};
